import React from 'react';
import { Card, SectionTitle, NumberField, StatusBox } from './components';

export default function VistaGerente({
  params, reglas, updateParam, updateRegla, onGuardarParams, onGuardarReglas, guardando, mensaje,
}) {
  return (
    <div className="grid gap-6 xl:grid-cols-2">
      <Card>
        <SectionTitle title="Parámetros financieros y costos" subtitle="Equivalente a hoja 01 del modelo." />
        <div className="grid gap-4">
          <NumberField label="Costo fondo mensual" value={params.costo_fondo_mensual} onChange={(v) => updateParam('costo_fondo_mensual', v)} suffix="decimal" step="0.00001" />
          <NumberField label="Spread mínimo" value={params.spread_minimo} onChange={(v) => updateParam('spread_minimo', v)} step="0.001" />
          <NumberField label="Contrato digital" value={params.contrato_digital} onChange={(v) => updateParam('contrato_digital', v)} prefix="$" />
          <NumberField label="Contrato notarial" value={params.contrato_notarial} onChange={(v) => updateParam('contrato_notarial', v)} prefix="$" />
          <NumberField label="Monto cobro notificación deudor" value={params.notificacion_por_deudor} onChange={(v) => updateParam('notificacion_por_deudor', v)} prefix="$" />
          <NumberField label="Facturas por cobro notificación" value={params.notificacion_facturas_por_cobro ?? 12} onChange={(v) => updateParam('notificacion_facturas_por_cobro', v)} suffix="facturas" />
          <NumberField label="Costo operación ≤ $5MM" value={params.costo_operacion_hasta_5mm} onChange={(v) => updateParam('costo_operacion_hasta_5mm', v)} prefix="$" />
          <NumberField label="Costo operación > $5MM" value={params.costo_operacion_sobre_5mm} onChange={(v) => updateParam('costo_operacion_sobre_5mm', v)} prefix="$" />
          <NumberField label="Cesión realizada" value={params.cesion_realizada} onChange={(v) => updateParam('cesion_realizada', v)} prefix="$" />
          <NumberField label="Plazo mínimo" value={params.reglas_pre_eval.plazo_minimo} onChange={(v) => updateParam('reglas_pre_eval', { ...params.reglas_pre_eval, plazo_minimo: v })} suffix="días" />
          <NumberField label="Plazo máximo" value={params.reglas_pre_eval.plazo_maximo} onChange={(v) => updateParam('reglas_pre_eval', { ...params.reglas_pre_eval, plazo_maximo: v })} suffix="días" />
          <button type="button" onClick={onGuardarParams} disabled={guardando} className="rounded-xl bg-blue-600 py-3 font-semibold text-white">
            Guardar parámetros
          </button>
        </div>
      </Card>

      <Card>
        <SectionTitle title="Reglas de pricing por clasificación" subtitle="Ajuste de tasa y flujo por código de deudor." />
        <div className="max-h-[520px] overflow-auto rounded-xl border border-slate-200">
          <table className="w-full min-w-[640px] text-left text-sm">
            <thead className="sticky top-0 bg-slate-100">
              <tr>
                <th className="p-2">Código</th>
                <th className="p-2">Banda</th>
                <th className="p-2">Ajuste tasa</th>
                <th className="p-2">Flujo</th>
              </tr>
            </thead>
            <tbody>
              {reglas.map((row, idx) => (
                <tr key={row.clasificacion} className="border-t border-slate-100">
                  <td className="p-2 font-semibold">{row.clasificacion}</td>
                  <td className="p-2">
                    <input className="w-full rounded-lg border px-2 py-1" value={row.banda_pricing} onChange={(e) => updateRegla(idx, 'banda_pricing', e.target.value)} />
                  </td>
                  <td className="p-2">
                    <input type="number" step="0.001" className="w-full rounded-lg border px-2 py-1" value={row.ajuste_tasa_mensual} onChange={(e) => updateRegla(idx, 'ajuste_tasa_mensual', Number(e.target.value))} />
                  </td>
                  <td className="p-2">
                    <select className="w-full rounded-lg border px-2 py-1" value={row.flujo} onChange={(e) => updateRegla(idx, 'flujo', e.target.value)}>
                      <option value="Automatico">Automático</option>
                      <option value="Revision manual">Revisión manual</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button type="button" onClick={onGuardarReglas} disabled={guardando} className="mt-4 w-full rounded-xl bg-slate-700 py-3 font-semibold text-white">
          Guardar reglas de pricing
        </button>
      </Card>

      {mensaje && (
        <div className="xl:col-span-2">
          <StatusBox ok={!mensaje.includes('Error')} title={mensaje.includes('Error') ? 'Error' : 'Listo'} text={mensaje} />
        </div>
      )}
    </div>
  );
}
